import React from 'react'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import axios from 'axios';
import {Mask} from 'react-weui';
import {Page} from '../components'
import {WKSlide, WKPreload, WKBottomNav, WKSearchBar} from '../components/wk'
import { isLZWKAPP, getJsonFromUrl } from '../utils'
import {
    MainInitComponent,
    MainPopupTab,
    MainRecommendBar,
    MainLivingLecture,
    MainMixBox,
    MainCacheData,
    MainGiftBar,
    MainGiftPopup,
    MainActiveCoupon,
    MainIntroSlider,
    MainNewNav,
    MainConfigurationBar,
} from '../components/main';
import '../css/page/MainPage.css';
import zhongqiu from '../images/activity/zhongqiu.png';


class ActivityDialog extends React.Component {
    render() {
        const {show, handleClick} = this.props;

        if (!show) {
            return null;
        }
        return (
            <div className="activity-dialog">
                <Mask onClick={handleClick}/>
                <div className="act-img wk-screen-center" onClick={handleClick}>
                    <img src={zhongqiu} alt="中秋节"/>
                </div>
            </div>
        )
    }
}

class MainPage extends React.Component {
    constructor() {
        super();
        this.state = {
            activityDialogShow: false,
            modules: [],
            scene: 'index',
            action: 'look'
        };
        this.loadData = this.loadData.bind(this);
        this.loadMoreData = this.loadMoreData.bind(this);
        this.loadLivingData = this.loadLivingData.bind(this);
        this.handleCloseActivityDialog = this.handleCloseActivityDialog.bind(this);
    }

    componentDidMount() {
        let search = window.location.search
        let r_url = getJsonFromUrl(search).redirect_url
        let store = window.sessionStorage.getItem(r_url)
        if (store) {
            window.sessionStorage.removeItem(r_url)
            window.location.replace('/?from_outside_new=1')
            return
        }
        window.gio && window.gio("page.set", "plan_a", 'version-A')
        document.title = '发现'
        this.loadData();
        // 解决返回黑屏的问题
        setTimeout(() => {
            window.scrollTo(0,1)
        }, 100)
    }

    componentWillUnmount() {
        this.props.dispatch({
            type: 'MAIN_UNSET_DATA'
        })
    }

    getChildContext() {
        return {mainPage: this};
    }

    handleBackFromOutside() {
        if (!window.localStorage.lzwk_id) {
            return
        }
        let search = window.location.search
        let a = document.createElement('a')
        a.id = 'middlePage'
        a.href = ''
        document.body.appendChild(a)
        let a_target = document.querySelector('#middlePage')
        if (!search) {
            return
        }
        let r_url = getJsonFromUrl(search).redirect_url
        if (!r_url) {
            return
        } else {
            r_url = decodeURIComponent(r_url)
        }

        window.addEventListener('pageshow', function(event) {
            if (event.persisted) {  //如果检测到页面是从“往返缓存”中读取的，重走逻辑
                window.sessionStorage.removeItem(r_url)
                window.location.replace('/?from_outside_new=1')
            }
        })

        window.sessionStorage.setItem(r_url, 1)

        setTimeout(() => {
            a.href = r_url
            a_target.click()
        }, 100)

    }

    handleCloseActivityDialog() {
        this.setState({activityDialogShow: false});
    }

    loadData(categoryId) {
        let {selectCategory} = this.props.main;
        if (categoryId || categoryId === 0) {
            selectCategory = categoryId;
            this.props.dispatch({type: 'WK_CLEAR_SLIDE'});
        } else {
            let cacheCategory = sessionStorage.getItem('newSelectedCategory');
            if (cacheCategory) {
                selectCategory = cacheCategory;
            }
        }

        if (isNaN(selectCategory)) {
            selectCategory = 0;
        }

        let data = {maxRedirects: 0, params: {category: selectCategory}};
        if (this.props.location.query.st) {
            data = {
                maxRedirects: 0,
                params: {
                    ...data.params,
                    st: this.props.location.query.st,
                }
            }
        }
        axios.get(`/account/api_get_category_index_n`, data).then((res) => {
            if (res.data.code === 0) {
                this.props.dispatch({
                    type: 'MAIN_INIT_DATA',
                    payload: Object.assign(res.data.data, {selectCategory: parseInt(selectCategory, 10)})
                });

                this.page.hideToast();

                if (getJsonFromUrl(window.location.search).redirect_url) {
                    this.handleBackFromOutside()
                }
            }
        })
    }

    loadMoreData() {
        const {selectCategory, page, recommend} = this.props.main;

        let data = {params: {category: selectCategory, p: page}};
        axios.get(`/account/api_get_category_lecture`, data).then((res) => {
            if (res.data.code === 0) {
                this.props.dispatch({
                    type: 'MAIN_LOAD_MORE_DATA',
                    payload: {
                        ret: res.data.data.ret,
                        hasMore: res.data.data.has_more,
                        cacheData: {
                            data: [...recommend.data.ret, ...res.data.data.ret],
                            page,
                            hasMore: res.data.data.has_more,
                            top: document.body.scrollTop,
                            categoryId: selectCategory,
                        }
                    }
                });
            }
        });
    }

    loadLivingData(p) {
        let {selectCategory} = this.props.main;
        axios.get(`/account/api_get_starting_lecture?category=${selectCategory}&p=${p}`).then((res) => {
            if (res.data.code === 0) {
                this.props.dispatch({
                    type: 'MAIN_LOAD_LIVING_DATA',
                    payload: {
                        ret: res.data.data.ret,
                        hasMore: res.data.data.has_more,
                    }
                })
            }
        });
    }

    renderContent() {
        const {activityDialogShow} = this.state;
        const {selectCategory} = this.props;

        return <div>
            {
                !isLZWKAPP() && !/redirect_url/.test(window.location.search) && (
                    <MainActiveCoupon location={this.props.location}/>
                )
            }

            <ActivityDialog show={activityDialogShow} handleClick={this.handleCloseActivityDialog}/>

            <MainInitComponent />

            <MainGiftPopup />

            <MainCacheData />

            <MainGiftBar />

            {
                !isLZWKAPP() && (
                    <div onClick={() => location.assign('/search')}>
                        <WKSearchBar />
                    </div>
                )
            }

            <MainNewNav />

            <MainPopupTab />

            <WKSlide />

            { !isLZWKAPP() && <MainRecommendBar /> }

            {selectCategory === 0 &&
            <MainConfigurationBar/>
            }

            <MainIntroSlider selectCategory={this.props.selectCategory} list={this.props.main.big_recommend.data.ret}/>

            <MainLivingLecture />

            <MainMixBox />

        </div>
    }

    render() {
        const {initialized} = this.props.main;

        return (
            <Page className="page-load-fade" parent={this}>
                <div className="wk-inner-page main-page">
                    {initialized ? this.renderContent() : <WKPreload />}
                    {
                        !isLZWKAPP() && <WKBottomNav/>
                    }
                </div>
            </Page>
        )
    }
}

MainPage.childContextTypes = {
    mainPage: React.PropTypes.object
};

export default connect((state) => ({
    main: state.main,
    account: state.account,
    selectCategory: state.main.selectCategory,
}))(MainPage)



// WEBPACK FOOTER //
// ./src/pages/MainPage.js